var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("SidebarWidget", {
    attrs: {
      title: _vm.$gettext("Aktionen"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "ul",
              {
                staticClass: "widget-list widget-links",
              },
              [
                _c(
                  "li",
                  [
                    _c("studip-icon", {
                      staticClass: "widget-action-icon",
                      attrs: {
                        shape: "upload",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: _vm.onUploadClick,
                        },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Bild hinzufügen")))]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }